import type { ReactNode } from "react";
import type { WorkflowSignalType } from "@entrilia/shared/api/workflowTypes";
import type { Field, ObjectClassDefinition } from "../../api/types/objectTypes";

export interface ObjectCardSource {
  label: string;
  description: string;
  readOnlyFieldIds: string[];
  relatedObjectType: string;
  readOnlyRelatedFieldIds: string[];
  workflowActionsWithChecks: WorkflowSignalType[];
  details?: ReactNode;
}

export const withReadOnlyFields = (fields: Field[], readOnlyFieldIds: string[]): Field[] =>
  fields.map((field) =>
    readOnlyFieldIds.includes(field.id) ? { ...field, attributes: [...field.attributes, "ReadOnly"] } : field
  );

export const withSource = (definition: ObjectClassDefinition, source: ObjectCardSource): ObjectClassDefinition => ({
  ...definition,
  fields: withReadOnlyFields(definition.fields, source.readOnlyFieldIds),
  workflowActionsWithChecks: [...(definition.workflowActionsWithChecks ?? []), ...source.workflowActionsWithChecks],
});
